<template>
  <nav class="header__subnav">
    <router-link :to="profileLink"
                 class="subnav-profile-link">
      <tt-avatar :own="true"
                 :class="{'b-header__nav-avatar--offset': userIsEnterpriseMember}"
                 class="b-header__account-avatar" />
      <company-avatar v-if="userIsEnterpriseMember"
                      :own="true"
                      class="b-header__account-logo" />
      <div class="subnav-profile-link__desription">
        <p class="subnav-profile-link__name">{{ fullName }}</p>
        <p class="subnav-profile-link__enterprise-name">{{ profileSubtitle }}</p>
      </div>
      <div class="subnav-link__arrow-icon"></div>
    </router-link>
    <div v-if="userIsEnterpriseMember"
         class="subnav-scope-selector">
      <template v-for="item in scopeItems">
        <button v-if="item.show"
                :key="item.key"
                :class="{'subnav-scope-selector__item-active': enterpriseMemberJobsScope === item.key}"
                class="subnav-scope-selector__item"
                @click="setScopeJobs(item.key)">
          {{ item.label }}
        </button>
      </template>
    </div>
    <template v-for="(item, index) in profileMenu">
      <menu-item
        v-if="item.condition"
        :key="index"
        :item="item"
        @action="handleMenuAction" />
    </template>
    <div class="header__subnav-footer">
      <div class="subnav-footer__external-links">
        <a v-if="links.privacy"
           target="_blank"
           :href="links.privacy"
           class="subnav-footer__external-link">{{ $gettext('Privacy') }}</a>
        <a v-if="links.terms"
           target="_blank"
           :href="links.terms"
           class="subnav-footer__external-link">{{ $gettext('Terms & Conditions') }}</a>
      </div>
      <div class="subnav-footer__social">
        <p>{{ links.copyright }}</p>
        <div v-if="!isCourtTheme">
          <a class="subnav-footer__icon-link subnav-footer__icon-link--twitter"
             target="_blank"
             :href="links.twitter"></a>
          <a class="subnav-footer__icon-link subnav-footer__icon-link--facebook"
             target="_blank"
             :href="links.facebook"></a>
          <a class="subnav-footer__icon-link subnav-footer__icon-link--linkedin"
             target="_blank"
             :href="links.linkedin"></a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import profileMenuBuyer from '@/modules/profileMenuBuyer';
  import profileMenuSupplier from '@/modules/profileMenuSupplier';
  import MenuItem from '@/components/navigations/header_account_subnav/MenuItem';

  export default {
    components: {
      'menu-item': MenuItem
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'userUid',
        'fullName',
        'userEnterpriseName',
        'userIsEnterpriseMember',
        'userIsNotInterpreter',
        'enterpriseMemberJobsScope',
        'isEmailVerificationRequired',
        'userIsBusiness',
        'userIsAdminOfEnterprise',
        'isCourtTheme',
        'isTranslationOnly'
      ]),
      isMobileView() { return this.$store.state.GlobalStore.clientWidth < 768; },
      profileLink() {
        return this.$makeRoute({
          name: this.userIsNotInterpreter ? 'BuyerUserProfileEdit' : 'ServerProfileEdit',
          params: {id: this.userUid}
        });
      },
      profileSubtitle() {
        return this.userIsNotInterpreter ? this.userEnterpriseName : this.$gettext('View profile');
      },
      settingsLink() {
        if (this.isTranslationOnly) {
          return this.$makeRoute({name: 'ServerTranslationNotifications', params: {id: this.userUid}});
        }
        return this.$makeRoute({
          name: this.isMobileView ? 'ServerPreferences' : 'ServerPreferencesAvailability',
          params: {id: this.userUid}
        });
      },
      links() {
        return {
          privacy: this.$getString('domainData', 'privacyLink'),
          terms: this.$getString('domainData', 'termLink'),
          twitter: this.$getString('social', 'twitterLink'),
          facebook: this.$getString('social', 'facebookLink'),
          linkedin: this.$getString('social', 'linkedinLink'),
          copyright: !this.isCourtTheme ? this.$getString('footer', 'copyright') : '© Domstoladministrasjonen'
        };
      },
      scopeItems() {
        return [
          {
            key: 'all_jobs',
            label: this.$gettext('All jobs'),
            show: this.userIsAdminOfEnterprise && !this.isEmailVerificationRequired
          },
          {
            key: 'department_jobs',
            label: this.$gettext('Department\'s jobs'),
            show: !this.isEmailVerificationRequired
          },
          {
            key: 'participant_jobs',
            label: this.$gettext('My jobs'),
            show: true
          }
        ];
      },
      profileMenu() {
        return this.userIsNotInterpreter
          ? profileMenuBuyer(this)
          : profileMenuSupplier(this);
      }
    },
    methods: {
      ...mapActions('UserInfoStore', ['updateJobsScope']),
      setScopeJobs(value) {
        this.updateJobsScope(value);
      },
      handleMenuAction(action) {
        const actionMap = {
          logOut: this.logOut,
          openAccessibilityModal: this.openAccessibilityModal,
          openInterpreterIdModal: this.openInterpreterIdModal
        };

        if (actionMap[action]) actionMap[action]();
      },
      openInterpreterIdModal() {
        this.$store.commit('ModalStore/setModal', {
          component: 'interpreter-id-modal',
          width: 360
        });
      },
      openAccessibilityModal() {
        this.$store.commit('ModalStore/setModal', {
          component: 'accessibility-modal',
        });
      },
      logOut() {
        this.$store.dispatch('TTAuthStore/logOut').then(() => {
          // set cookie for preventing mobile app redirect after clicking on logout button
          this.$cookieManager.setCookie('preventMobileAppRedirect', true, {path: '/', expires: 2592000});
          setTimeout(() => {
            this.$goToExternalLoginPage();
          }, 0);
        });
      }
    }
  };
</script>
